import * as angular from "angular";
import { IShift, ShiftService } from "../services/shifts.service";
import * as moment from "moment";
import { INewsItem, NewsService } from "../services";
import { AuthService } from "../authorization/services/index";

class NavbarController implements ng.IComponentController {

    private logo: string;
    private userName: string;
    private currentShift: IShift;
    private shifts: IShift[];
    private news: INewsItem[];
    unreadCnt: any;

    isBackoffice = false;
    isCustomer = false;
    isEmployee = false;
    readLater: boolean;

    constructor(private ThemeService: aboTheme.IThemeService,
                private ShiftService: ShiftService,
                private NewsService: NewsService,
                private $scope: ng.IScope, 
                private $interval: ng.IIntervalService,
                private SweetAlert: any,
                private AuthService: AuthService) {
        'ngInject';
    }

    public $onInit = () => {
        this.logo = this.ThemeService.getLogoDark();
        
        
        this.isBackoffice = this.AuthService.hasRole('backoffice');
        this.isCustomer = this.AuthService.hasRole('customer');
        this.isEmployee = this.AuthService.hasRole('employee');

        this.unreadCnt = 0;

        this.getNewsCount();

        var theInterval = this.$interval(function(){
            this.getNewsCount();
         }.bind(this), 60000);    
       
    }

    openResetPasswordModal() {
        (<any>$('#ResetPasswordModal')).modal('show');
    }

    private toggleSidebar = () => {
        angular.element('.app').toggleClass('offscreen move-left');
    }

    private toggleSlider = () => {
        angular.element('.app').toggleClass('layout-chat-open');
        if (angular.element('.app').hasClass('layout-chat-open')) {
            this.ShiftService.customAll('getAdHoc').then((result) => {
                this.shifts = result;
            });
        }
        // this.$scope.$emit('getAdHocShiftsUp', null);
    }

    private toggleNewsSlider = () => {
        angular.element('.app').toggleClass('layout-news-open');
        if (angular.element('.app').hasClass('layout-news-open')) {
            this.NewsService.all().then((result) => {
                this.news = result;
            });
        }
    }

    showAvailModal() {
        this.currentShift = new IShift();
        this.currentShift.start = this.roundMinutes(new Date());
        this.currentShift.end = moment(this.currentShift.start).add(8, 'hour').toDate();
        (<any>$('#check-availability-modal')).modal('show');
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    getNewsCount() {
        if(this.isEmployee || this.isCustomer) {
            this.NewsService.getUnread().then(result => {

            var newitems =  this.unreadCnt < result.size;
            this.unreadCnt = result.size;
            if(this.unreadCnt > 0) {

                if(this.unreadCnt == 1){
                    var text = "Er staat "+ this.unreadCnt +" nieuw bericht voor je klaar."
                } else {
                    var text = "Er staan "+ this.unreadCnt +" nieuwe berichten voor je klaar."
                }

                if(newitems) {
        
                    this.SweetAlert.swal({
                        title: 'Er zijn nieuwe nieuwsberichten',
                        text: text,
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Nu lezen',
                        cancelButtonText: 'Ik lees ze later',
                    }, (isConfirm) => {
                        if (isConfirm) {
                            this.readLater = true;
                            this.toggleNewsSlider();
                        } else {
                            this.readLater = true;
                        }
                    });
                }
            }
            });
        }
    }
 };

export const operandoNavbar : aboTheme.IComponent = {
    bindings: {
        userName: '<',
        shifts: '=',
        news: '=',
        currentShift: '='
    },
    controller: NavbarController,
    template: require('./navbar.html')
};



// WEBPACK FOOTER //
// ./src/app/main/navbar.component.ts